module.exports = __webpack_public_path__ + "media/images/mobile-only/mobile-only-4-04aefd8d7867df8125d50344e303f65d.png";